import { browser, building } from "$app/env";
import { consoleClient } from "#lib/api.ts";
import { BASE_LOCALE, basePath, getLocale, overwriteGetLocale } from "#lib/locale.ts";
import type { Locale } from "#lib/locale.ts";
import { PUBLIC_PATHS } from "#lib/seo/site.ts";
import { sessionHinted, sessionUser } from "#lib/shell/me.ts";
import type { SessionUser } from "#lib/shell/me.ts";
import type { LayoutLoad } from "./$types.ts";

export const prerender = false;

export interface RootData {
  readonly locale: Locale;
  readonly me: SessionUser | null;
}

export const load: LayoutLoad = async ({ fetch, url, untrack }): Promise<RootData> => {
  if (building) return { locale: BASE_LOCALE, me: null };
  const locale = getLocale();
  if (browser) overwriteGetLocale(() => locale);
  const publicPage = untrack(() => PUBLIC_PATHS.includes(basePath(url.pathname)));
  const me = publicPage && !sessionHinted() ? null : await sessionUser(consoleClient(fetch));
  return { locale, me };
};
